import React from "react";
import hero from '../../assets/images/homePage/hero-illustration.png'
import useTranslation from "../../Languages/Translation";

function HeroSection() {

  const translation = useTranslation();

  return (
    <div className="flex flex-col-reverse lg:flex-row items-center">
      <div className="w-[100%] lg:w-[50%]">
        <div className="max-w-[470px] 2xl:max-w-[670px] mx-auto 2xl:mx-0 2xl:ml-auto px-[20px] md:px-0 lg:mt-[110px]">
          <p className="text-white text-[30px] md:text-[55px] 2xl:text-[80px] aeonik_normal md:leading-[125%]">
            {translation.InflationProtectedStablecoin}
          </p>
          <p className="text-white text-[20px] md:text-[24px] md:pt-[12px] aeonik_normal">{translation.ReservesYieldManagedbyPikuDAO}</p>
          <div className="pt-[30px] md:pt-[64px] flex items-center">
            <a href="" className='text-black mr-[16px] rounded-[150px] py-[12px] px-[24px]  text-[18px] aeonik_medium bg-sky flex justify-center'>{translation.ExplorePIKU}</a>
            <a href="" className='text-white px-[24px] max-w-[153px] text-[18px] aeonik_medium flex justify-center'>{translation.LearnMore}</a>
          </div>
        </div>
      </div>
      <div className="lg:w-[50%]">
        <img src={hero} alt="hero" className="ml-auto"></img>
      </div>
    </div>
  );
}

export default HeroSection;
